// /src/utils/languageUtils.js
export const extractLanguageName = (label) => {
    return label.split(' ')[1];
};
